import type * as bytescale from "@bytescale/sdk";

function isBytescaleApiError(
  error: Error,
): error is bytescale.BytescaleApiError {
  return "name" in error && error.name === "BytescaleApiError";
}

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    if (isBytescaleApiError(error)) {
      return error.errorCode;
    }

    return error.message;
  }

  return "An unknown error occurred";
}
